<template>
  <vx-card class="shadow-2xl">
    <div v-if="shoppingCardInfo.products.length <= 0" class="text-center">
      سبد خرید شما خالی است
    </div>
    <template v-else>
      <div
        v-if="cartVisibility"
        style="
          overflow-y: auto;
          max-height: 220px;
          overscroll-behavior: contain;
        "
      >
        <shop-item
          v-for="product in shoppingCardInfo.products"
          :product="product"
          :key="product.id"
          @add="$emit('add', product.product)"
          @remove="$emit('remove', product.product)"
          @remove-all="$emit('remove-all', product.product)"
        ></shop-item>
      </div>
      <vs-divider v-show="cartVisibility" class="my-3"></vs-divider>
      <div class="flex justify-between items-center pb-1">
        <span class="font-bold text-xl text-primary">سبد خرید</span>
        <p class="final-price flex gap-1 items-center">
          تعداد:‌
          <span
            class="price border border-primary rounded-full flex items-center justify-center w-8 h-8"
            >{{ shoppingCardProductsCount }}</span
          >
        </p>
      </div>
      <div class="row">
        <div class="flex-1 flex items-center justify-center">
          <p class="final-price">
            قیمت نهایی:
            <span class="price">{{
              shoppingCardInfo.finalPrice.toString().numberFormat()
            }}</span>
            ریال
          </p>
        </div>
      </div>
      <vs-divider class="my-3"></vs-divider>
      <div class="flex gap-2">
        <vs-button
          @click="$emit('create-order')"
          color="primary"
          class="w-full flex-1"
          block
        >
          ادامه فرآیند
        </vs-button>
        <button
          style="border-radius: 6px"
          class="flex-1 px-6 py-3 border flex items-center justify-center gap-2 border-primary text-primary"
          @click="toggleCartVisibility()"
          color="primary"
        >
          <img
            class="w-4 h-4 transition-all duration-200"
            :style="`${!cartVisibility ? 'rotate: 180deg;' : ''}`"
            src="../../../../assets/icons/arrow.svg"
          />
          {{ cartVisibility ? "پنهان کردن" : "نمایش سبد" }}
        </button>
      </div>
    </template>
  </vx-card>
</template>

<script>
  import ShopItem from "./ShopItem.vue";

  export default {
    name: "ShoppingCard",
    data() {
      return {
        cartVisibility: false,
      };
    },
    computed: {
      shoppingCardProductsCount() {
        let count = 0;
        this.shoppingCardInfo.products.forEach((item) => {
          count += item.unit;
        });
        return count;
      },
    },
    props: {
      shoppingCardInfo: {
        required: true,
        type: Object,
      },
    },
    components: {
      ShopItem,
    },
    methods: {
      toggleCartVisibility() {
        this.cartVisibility = !this.cartVisibility;
      },
    },
  };
</script>

<style scoped lang="scss">
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .final-price {
    font-size: 16px;
    color: #141e47;

    .price {
      font-weight: 800;
    }
  }
</style>
